import type { PollCreate } from '@/features/post-editor/types/poll';
import { dayjs } from '@/time';

export const MIN_OPTION_COUNT = 2;
export const MAX_OPTION_COUNT = 5;

export const EMPTY_POLL_CREATE: PollCreate = {
  text: '',
  multipleChoice: false,
  expirationTime: dayjs()
    .add(7, 'day')
    .add(1, 'hour')
    .set('minute', 0)
    .toDate()
    .getTime(),
  optionTexts: [{ optionText: '' }, { optionText: '' }]
};
